import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable, withLatestFrom } from 'rxjs';
import { CommonService } from 'src/app/shared/services/common.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private appService: CommonService,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.appService._isIdpTokenSet.pipe(
      withLatestFrom(this.appService._isFknKeySet)
    ).pipe(
      map((data: boolean[]) => {
        const isFknKeySet = sessionStorage.getItem('selectedFknKey');//data[1];
        console.log("[Guard] found ", isFknKeySet);
        if (isFknKeySet && isFknKeySet.length > 5) {
          console.log("[Guard] access granted");
          return true;
        } else {
          console.log("[Guard] access denied");
          this.router.navigate([`/remote`]);
          return false;
        }
      })
    )
  }

}
